export interface VideoNaturalSize {
  width: number
  height: number
  duration: number
}

export function readVideoFileNaturalSize(file: File): Promise<VideoNaturalSize> {
  let objectUrl = ''

  try {
    objectUrl = URL.createObjectURL(file)
  } catch {
    return Promise.reject(new Error('视频加载异常，无法读取尺寸'))
  }

  return new Promise<VideoNaturalSize>((resolve, reject) => {
    const video = document.createElement('video')
    video.preload = 'metadata'

    function cleanup() {
      video.onloadedmetadata = null
      video.onerror = null
      URL.revokeObjectURL(objectUrl)
    }

    video.onloadedmetadata = () => {
      const width = video.videoWidth
      const height = video.videoHeight
      const duration = video.duration
      cleanup()

      if (!width || !height) {
        reject(new Error('视频加载异常，无法读取尺寸'))
        return
      }

      resolve({ width, height, duration })
    }

    video.onerror = () => {
      cleanup()
      reject(new Error('视频加载异常，无法读取尺寸'))
    }

    video.src = objectUrl
  })
}

export function readVideoUrlNaturalSize(url: string): Promise<VideoNaturalSize> {
  return new Promise<VideoNaturalSize>((resolve, reject) => {
    const video = document.createElement('video')
    video.preload = 'metadata'
    video.crossOrigin = 'anonymous'

    function cleanup() {
      video.onloadedmetadata = null
      video.onerror = null
      video.removeAttribute('src')
      video.load()
    }

    video.onloadedmetadata = () => {
      const width = video.videoWidth
      const height = video.videoHeight
      const duration = video.duration
      cleanup()

      if (!width || !height) {
        reject(new Error('视频加载异常，无法读取尺寸'))
        return
      }

      resolve({ width, height, duration })
    }

    video.onerror = () => {
      cleanup()
      reject(new Error('视频加载异常，无法读取尺寸'))
    }

    video.src = url
  })
}
